import { Reveal } from "@/components/Reveal";

const EDIT_SUITE_IMG =
  "https://images.pexels.com/photos/15713296/pexels-photo-15713296.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const PHASES = [
  {
    no: "I",
    phase: "Pre-Production",
    action: "Plan",
    copy: "Budget preparation, vendor benchmarking, commercial negotiation and cost planning.",
  },
  {
    no: "II",
    phase: "Production / Shoot",
    action: "Monitor",
    copy: "Daily expense monitoring, production audit, crew/vendor verification and budget variance.",
  },
  {
    no: "III",
    phase: "Post-Production",
    action: "Reconcile",
    copy: "Vendor audit, invoice verification, accruals, commitments and department reconciliation.",
  },
  {
    no: "IV",
    phase: "Project Closure",
    action: "Close",
    copy: "Final vendor reconciliation, outstanding tracking, final cost consolidation and EFC / COP reporting.",
  },
];

export default function Lifecycle() {
  return (
    <section id="lifecycle" data-testid="lifecycle-section" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <Reveal>
          <p className="mb-4 flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.28em] text-[#D4AF37]">
            <span className="h-px w-10 bg-[#B79045]" /> Project Lifecycle
          </p>
          <h2 className="max-w-3xl font-display text-4xl font-medium leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
            Support Across the Entire{" "}
            <em className="italic text-[#D4AF37]">Production Journey</em>
          </h2>
        </Reveal>

        <Reveal delay={0.15} className="mt-14 md:mt-20">
          <div className="relative overflow-hidden">
            <img
              src={EDIT_SUITE_IMG}
              alt="Film editing suite during post-production"
              loading="lazy"
              className="h-56 w-full object-cover md:h-80"
            />
            <div
              className="absolute inset-0"
              style={{
                background:
                  "radial-gradient(ellipse at 50% 100%, transparent 20%, rgba(5,5,5,0.8) 100%)",
              }}
            />
            <span className="absolute bottom-4 left-5 font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-400">
              Fig. 01 — The Cutting Room
            </span>
          </div>
        </Reveal>

        <div className="mt-0 grid grid-cols-1 border-l border-white/10 sm:grid-cols-2 lg:grid-cols-4">
          {PHASES.map((p, i) => (
            <Reveal key={p.no} delay={i * 0.1} className="h-full">
              <div
                data-testid={`lifecycle-phase-${i + 1}`}
                className="group flex h-full flex-col border-b border-r border-white/10 p-8 transition-colors duration-500 hover:bg-[#0f0d09] md:p-10"
              >
                <span className="font-mono text-xs text-[#B79045]">{p.no}</span>
                <h3 className="mt-6 font-mono text-[11px] uppercase tracking-[0.25em] text-neutral-500">
                  {p.phase}
                </h3>
                <p className="mt-2 font-display text-3xl font-medium italic text-neutral-100 transition-colors duration-300 group-hover:text-[#D4AF37] md:text-4xl">
                  {p.action}
                </p>
                <p className="mt-6 text-sm leading-relaxed text-neutral-400">{p.copy}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
